export const typeAdSpace = "ad space";

export const roleClient = "ROLE_CLIENT";

export const ONGOING = "onGoing";
export const VALIDATED = "validated";
export const ARCHIVED = "archived";
export const CANCELLED = "cancelled";

export const SOCLE_APPROVAL_STATUS_RECOMMENDED: string = "30_recommended";
export const SOCLE_APPROVAL_STATUS_PENDING: string = "10_pending_approval";
export const SOCLE_APPROVAL_STATUS_APPROVED: string = "50_approved";

export const STATUS_CHANGED = "status_changed";
export const NOTE_ADDED = "note_added";
export const TYPE_CAMPAIGN = "campaign";
export const TYPE_REGULARIZATION = "regularization";
export const TYPE_MANDATORY_SUPPLIER = "supplier_mandatory";
export const SOCLE_NOTIFICATION_TRIGGER_REMINDER = "reminder";
export const openedStatus = {key: "opened", label: "opened"};

export const permissions = {
    reportAiCharlie: "PERM_CP_REPORT_AI_AGENT",
    competitorAccess: "PERM_CP_COMPETITOR_ACCESS",
};

export const ptfFeatures = {
    request: "REQUEST",
    billing: "BILLING",
    report: "REPORT",
    admin: "ADMIN",
    zero_waste: "ZERO_WASTE",
    homepage: "HOMEPAGE",
    socle: "SOCLE",
    topic: "TOPIC",
    competitor: "COMPETITOR",
};

export const kpiSocleConfig = {
    reach: "reach",
    traffic: "traffic",
    turnover: "turnover",
};

export const budgetRulesSocleConfig = {
    fixed: "fixed",
    free: "free",
    all_or_nothing: "all_or_nothing",
};

export const optionsMedia: any = [
    {key: "AFFICHAGE", translationKey: "boardNetwork", class: "sign"},
    {key: "RADIO", translationKey: "radioEmitter", class: "broadcast-tower"},
    {key: "CINEMA", translationKey: "cinema", class: "film"},
    {key: "AUTRES MEDIA", translationKey: "otherMedia", class: "stop-circle"},
    {key: "DIGITAL", translationKey: "digital", class: "globe"},
    {key: "DIGITAL - MANAGED", translationKey: "digitalManaged", class: "globe"},
    {key: "DIGITAL - SELF SERVICE", translationKey: "digitalSelfService", class: "globe"},
    {key: "PRODUCTION - DIGITAL", translationKey: "productionDigital", class: "globe"},
    {key: "DOOH - DIGITAL OUT OF HOME", translationKey: "dooh", class: "caret-square-right"},
    {key: "PRESSE", translationKey: "press", class: "newspaper"},
    {key: "TELEVISION", translationKey: "television", class: "tv"},
    {key: "SPONSORING TELEVISION", translationKey: "televisionSponsoring", class: "tv"},
    {key: "TELEVISION SEGMENTEE", translationKey: "segmentedTelevision", class: "tv"},
    {key: "PRODUCTION - CONSEIL", translationKey: "productionCouncil", class: "user-tie"},
    {key: "IMPRIME SANS ADRESSE", translationKey: "balIsa", class: "envelope-open-text"},
    {key: "STREET MARKETING", translationKey: "streetMarket", class: "bullhorn"},
    {key: "PARTENARIAT", translationKey: "partenariat", class: "hands-helping"},
    {key: "PRODUCTION - CONTENT FACTORY", translationKey: "productionContentFactory", class: "industry"},
    {key: "RETAIL MEDIA", translationKey: "retailMedia", class: "globe"},
];

export const optionsZone = [
    {
        canonical_name: "occitanie",
        options:
            [
                {key: "Occitanie", label: "Occitanie", selectUnique: true},
                {key: "Hors Occitanie / Natio / Inter", label: "Hors Occitanie / Natio / Inter", selectUnique: true},
                {key: "09", label: "09", selectUnique: false},
                {key: "11", label: "11", selectUnique: false},
                {key: "12", label: "12", selectUnique: false},
                {key: "30", label: "30", selectUnique: false},
                {key: "31", label: "31", selectUnique: false},
                {key: "32", label: "32", selectUnique: false},
                {key: "34", label: "34", selectUnique: false},
                {key: "46", label: "46", selectUnique: false},
                {key: "48", label: "48", selectUnique: false},
                {key: "65", label: "65", selectUnique: false},
                {key: "66", label: "66", selectUnique: false},
                {key: "81", label: "81", selectUnique: false},
                {key: "82", label: "82", selectUnique: false},
            ]
    },
    {
        canonical_name: "port_aventura",
        options:
            [
                {key: "Global (all regions)", label: "Global (all regions)", selectUnique: true},
                {key: "National", label: "National", selectUnique: true},
                {key: "South 1.5 (NA + RA)", label: "South 1.5 (NA + RA)", selectUnique: true},
                {key: "South 1 (Occitanie + PACA)", label: "South 1 (Occitanie + PACA)", selectUnique: true},
                {key: "IDF / Paris", label: "IDF / Paris", selectUnique: true},
                {key: "Rhône Alpes + Occitanie", label: "Rhône Alpes + Occitanie", selectUnique: true},
                {key: "Montpellier / Perpignan / Toulouse / Marseille", label: "Montpellier / Perpignan / Toulouse / Marseille", selectUnique: true},
                {key: "Rhône Alpes", label: "Rhône Alpes", selectUnique: true},
                {key: "Nouvelle Aquitaine", label: "Nouvelle Aquitaine", selectUnique: true},
                {key: "Occitanie", label: "Occitanie", selectUnique: true},
                {key: "Montpellier", label: "Montpellier", selectUnique: true},
                {key: "Perpignan", label: "Perpignan", selectUnique: true},
                {key: "Toulouse", label: "Toulouse", selectUnique: true},
                {key: "Marseille", label: "Marseille", selectUnique: true},
            ]
    }
];

export const optionsStatus: any = [
    {key: "engaged", label: "engaged", tag: true},
    {key: "invoiced", label: "invoiced", tag: true},
    {key: "paid", label: "paid", tag: true},
    {key: "cancelled", label: "cancelled", tag: true},
];

export const optionsDocumentType: any = [
    {key: "", label: "allInvoiceDocumentTypes"},
    {key: "proof", label: "proofs"},
    {key: "invoice_support", label: "invoices"},
];

export const optionsProofs: any = [
    {key: "", label: "proofs"},
    {key: "with", label: "insertionsWithProofs"},
    {key: "without", label: "insertionWithoutProofs"},
];

export const optionsSupportInvoices: any = [
    {key: "", label: "supportInvoices"},
    {key: "with", label: "insertionsWithSupportInvoices"},
    {key: "without", label: "insertionWithoutSupportInvoices"},
];

export const optionsCompetitorStatus: any = [
    { key: "", label: "allStatus" },
    { key: "onGoing", label: "onGoing" },
    { key: "validated", label: "validated" },
];

export const fileType: any = [
    { key: "PDF", type: "application/pdf" },
    { key: "XLS", type: "application/vnd.ms-excel" },
    { key: "XLSX", type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" },
    { key: "DOC", type: "application/application/msword" },
    { key: "DOCX", type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" },
    { key: "PPT", type: "application/vnd.ms-powerpoint" },
    { key: "PPTX", type: "application/vnd.openxmlformats-officedocument.presentationml.presentation" },
    { key: "JPEG", type: "image/jpeg" },
    { key: "PNG", type: "image/png" },
    { key: "ZIP", type: "application/zip" },
    { key: "XZIPC", type: "application/x-zip-compressed" },
    { key: "ZIPC", type: "application/zip-compressed" },
];

export const requestStatus = {
    draft: "draft",
    todo: "todo",
    onGoing: "onGoing",
    toValidate: "toValidate",
    validated: "validated",
    quoteCreated: "quoteCreated",
    goodForOrder: "goodForOrder",
    partialPurchaseOrder: "partialPurchaseOrder",
    processedPurchaseOrder: "processedPurchaseOrder",
    completed: "completed",
    cancelled: "cancelled",
    crea: "crea",
};

export const monocleStatus = {
    draft: "draft",
    ready: "ready",
    exported: "exported",
    archived: "archived",
};

export const monocleStatusFull = [
    "draft",
    "ready",
    "archived"
];

export const monocleStatusStateMachine = {
    draft: [monocleStatus.draft, monocleStatus.ready, monocleStatus.archived],
    ready: [monocleStatus.ready, monocleStatus.exported, monocleStatus.archived],
    exported: [monocleStatus.exported, monocleStatus.archived],
};

export const socleBudgetStatus = {
    toValidate: "toValidate",
    validated: "validated",
    notValidated: "notValidated",
};

export const socleApprovalStatus = [
    SOCLE_APPROVAL_STATUS_RECOMMENDED,
    SOCLE_APPROVAL_STATUS_PENDING,
    SOCLE_APPROVAL_STATUS_APPROVED,
];

export const catalogStatus = {
    toValidate: "toValidate",
    validated: "validated",
    notValidated: "notValidated",
};

export const compensationStrategy = {
    digitalCatalog: "Catalogue digital",
    compensation: "Compensation",
    surpression: "Surpression",
};

export const optionsStatusMonocle: any = [
    {key: openedStatus.key, label: openedStatus.label},
    {key: "", label: "allStatus"},
    {key: monocleStatus.draft, label: monocleStatus.draft, tag: true},
    {key: monocleStatus.ready, label: monocleStatus.ready, tag: true},
    {key: monocleStatus.exported, label: monocleStatus.exported, tag: true},
    {key: monocleStatus.archived, label: monocleStatus.archived, tag: true},
];

export const optionsStatusRequest: any = [
    {key: openedStatus.key, label: openedStatus.label},
    {key: requestStatus.draft, label: requestStatus.draft, tag: true},
    {key: requestStatus.todo, label: requestStatus.todo, tag: true},
    {key: requestStatus.onGoing, label: requestStatus.onGoing, tag: true},
    {key: requestStatus.toValidate, label: requestStatus.toValidate, tag: true},
    {key: requestStatus.validated, label: requestStatus.validated, tag: true},
    {key: requestStatus.crea, label: requestStatus.crea, tag: true},
    {key: requestStatus.quoteCreated, label: requestStatus.quoteCreated, tag: true},
    {key: requestStatus.goodForOrder, label: requestStatus.goodForOrder, tag: true},
    {key: requestStatus.partialPurchaseOrder, label: requestStatus.partialPurchaseOrder, tag: true},
    {key: requestStatus.processedPurchaseOrder, label: requestStatus.processedPurchaseOrder, tag: true},
    {key: requestStatus.completed, label: requestStatus.completed, tag: true},
    {key: requestStatus.cancelled, label: requestStatus.cancelled, tag: true},
];

export const optionsCompensationStrategy: any = [
    {key: "", label: "allCompensationStrategy"},
    {key: compensationStrategy.digitalCatalog, label: compensationStrategy.digitalCatalog},
    {key: compensationStrategy.compensation, label: compensationStrategy.compensation},
    {key: compensationStrategy.surpression, label: compensationStrategy.surpression}
];

export const optionsRight: any = [
    {key: "", label: "allRequesters"},
    {key: "user", label: "myRequests"}
];

export const optionsRequestType: any = [
    {key: "", label: "allRequestTypes"},
    {key: TYPE_CAMPAIGN, label: TYPE_CAMPAIGN},
    {key: TYPE_REGULARIZATION, label: TYPE_REGULARIZATION},
    {key: TYPE_MANDATORY_SUPPLIER, label: TYPE_MANDATORY_SUPPLIER},
];

export const optionsTrigger: any = [
    {key: STATUS_CHANGED, label: STATUS_CHANGED},
    {key: NOTE_ADDED, label: NOTE_ADDED}
];

export const requestStatusClientStateMachineByOwner: { [client: string]: { [key: string]: string[] }} = {
    default: {
        draft: [requestStatus.draft, requestStatus.todo],
        todo: [requestStatus.draft, requestStatus.todo, requestStatus.validated],
        onGoing: [requestStatus.onGoing],
        toValidate: [requestStatus.onGoing, requestStatus.toValidate, requestStatus.validated],
        validated: [requestStatus.validated, requestStatus.goodForOrder],
        quoteCreated: [requestStatus.quoteCreated, requestStatus.goodForOrder],
        goodForOrder: [requestStatus.goodForOrder],
        partialPurchaseOrder: [requestStatus.partialPurchaseOrder],
        processedPurchaseOrder: [requestStatus.processedPurchaseOrder],
        completed: [requestStatus.completed],
        cancelled: [requestStatus.cancelled],
    },
    aldi: {
        draft: [requestStatus.draft, requestStatus.todo],
        todo: [requestStatus.draft, requestStatus.todo, requestStatus.validated],
        onGoing: [requestStatus.onGoing],
        toValidate: [requestStatus.onGoing, requestStatus.toValidate, requestStatus.validated],
        validated: [requestStatus.validated, requestStatus.crea],
        crea: [requestStatus.crea, requestStatus.completed],
        completed: [requestStatus.completed],
        cancelled: [requestStatus.cancelled],
    },
    cora: {
        draft: [requestStatus.draft, requestStatus.todo],
        todo: [requestStatus.draft, requestStatus.todo, requestStatus.validated],
        onGoing: [requestStatus.onGoing],
        toValidate: [requestStatus.onGoing, requestStatus.toValidate, requestStatus.validated],
        validated: [requestStatus.validated],
        quoteCreated: [ requestStatus.quoteCreated ],
        completed: [requestStatus.completed],
        cancelled: [requestStatus.cancelled],
    },
    picard: {
        draft: [requestStatus.draft, requestStatus.todo],
        todo: [requestStatus.draft, requestStatus.todo, requestStatus.validated],
        onGoing: [requestStatus.onGoing],
        toValidate: [requestStatus.onGoing, requestStatus.toValidate, requestStatus.validated],
        validated: [requestStatus.validated],
        quoteCreated: [ requestStatus.quoteCreated ],
        completed: [requestStatus.completed],
        cancelled: [requestStatus.cancelled],
    },
    carrefour: {
        draft: [requestStatus.draft, requestStatus.todo],
        todo: [requestStatus.draft, requestStatus.todo, requestStatus.validated],
        onGoing: [requestStatus.onGoing],
        toValidate: [requestStatus.onGoing, requestStatus.toValidate, requestStatus.validated],
        validated: [requestStatus.validated],
        quoteCreated: [ requestStatus.quoteCreated ],
        completed: [requestStatus.completed],
        cancelled: [requestStatus.cancelled],
    },
    carter_cash: {
        draft: [requestStatus.draft, requestStatus.todo],
        todo: [requestStatus.draft, requestStatus.todo, requestStatus.validated],
        onGoing: [requestStatus.onGoing],
        toValidate: [requestStatus.onGoing, requestStatus.toValidate, requestStatus.validated],
        validated: [requestStatus.validated],
        quoteCreated: [ requestStatus.quoteCreated ],
        completed: [requestStatus.completed],
        cancelled: [requestStatus.cancelled],
    },
};
/* tslint:disable:max-line-length */
export const requestStatusNonClientStateMachineByOwner: { [client: string]: { [key: string]: string[] }} = {
    default: {
        draft: [ requestStatus.draft, requestStatus.todo, requestStatus.cancelled ],
        todo: [ requestStatus.draft, requestStatus.todo, requestStatus.onGoing, requestStatus.validated, requestStatus.cancelled ],
        onGoing: [ requestStatus.onGoing, requestStatus.toValidate, requestStatus.validated, requestStatus.cancelled ],
        toValidate: [ requestStatus.onGoing, requestStatus.toValidate, requestStatus.validated, requestStatus.cancelled ],
        validated: [ requestStatus.validated, requestStatus.quoteCreated, requestStatus.cancelled ],
        quoteCreated: [ requestStatus.quoteCreated, requestStatus.goodForOrder, requestStatus.cancelled ],
        goodForOrder: [ requestStatus.quoteCreated, requestStatus.goodForOrder, requestStatus.partialPurchaseOrder, requestStatus.processedPurchaseOrder, requestStatus.completed, requestStatus.cancelled ],
        partialPurchaseOrder: [ requestStatus.quoteCreated, requestStatus.goodForOrder, requestStatus.partialPurchaseOrder, requestStatus.processedPurchaseOrder],
        processedPurchaseOrder: [ requestStatus.quoteCreated, requestStatus.goodForOrder, requestStatus.partialPurchaseOrder, requestStatus.processedPurchaseOrder, requestStatus.completed],
        completed: [ requestStatus.quoteCreated, requestStatus.completed, requestStatus.cancelled ],
        cancelled: [ requestStatus.todo, requestStatus.onGoing, requestStatus.toValidate, requestStatus.cancelled ],
    },
    aldi: {
        draft: [ requestStatus.draft, requestStatus.todo, requestStatus.cancelled ],
        todo: [ requestStatus.draft, requestStatus.todo, requestStatus.onGoing, requestStatus.validated, requestStatus.cancelled ],
        onGoing: [ requestStatus.onGoing, requestStatus.toValidate, requestStatus.validated, requestStatus.cancelled ],
        toValidate: [ requestStatus.onGoing, requestStatus.toValidate, requestStatus.validated, requestStatus.cancelled ],
        validated: [ requestStatus.validated, requestStatus.crea, requestStatus.completed, requestStatus.cancelled ],
        crea: [requestStatus.crea, requestStatus.completed, requestStatus.cancelled],
        completed: [ requestStatus.completed, requestStatus.cancelled ],
        cancelled: [ requestStatus.todo, requestStatus.onGoing, requestStatus.toValidate, requestStatus.cancelled ],
    },
    cora: {
        draft: [ requestStatus.draft, requestStatus.todo, requestStatus.cancelled ],
        todo: [ requestStatus.draft, requestStatus.todo, requestStatus.onGoing, requestStatus.validated, requestStatus.cancelled ],
        onGoing: [ requestStatus.onGoing, requestStatus.toValidate, requestStatus.validated, requestStatus.cancelled ],
        toValidate: [ requestStatus.onGoing, requestStatus.toValidate, requestStatus.validated, requestStatus.cancelled ],
        validated: [ requestStatus.validated, requestStatus.quoteCreated, requestStatus.cancelled ],
        quoteCreated: [ requestStatus.quoteCreated, requestStatus.completed, requestStatus.cancelled ],
        completed: [ requestStatus.quoteCreated, requestStatus.completed, requestStatus.cancelled ],
        cancelled: [ requestStatus.todo, requestStatus.onGoing, requestStatus.toValidate, requestStatus.cancelled ],
    },
    picard: {
        draft: [ requestStatus.draft, requestStatus.todo, requestStatus.cancelled ],
        todo: [ requestStatus.draft, requestStatus.todo, requestStatus.onGoing, requestStatus.validated, requestStatus.cancelled ],
        onGoing: [ requestStatus.onGoing, requestStatus.toValidate, requestStatus.validated, requestStatus.cancelled ],
        toValidate: [ requestStatus.onGoing, requestStatus.toValidate, requestStatus.validated, requestStatus.cancelled ],
        validated: [ requestStatus.validated, requestStatus.quoteCreated, requestStatus.cancelled ],
        quoteCreated: [ requestStatus.quoteCreated, requestStatus.completed, requestStatus.cancelled ],
        completed: [ requestStatus.quoteCreated, requestStatus.completed, requestStatus.cancelled ],
        cancelled: [ requestStatus.todo, requestStatus.onGoing, requestStatus.toValidate, requestStatus.cancelled ],
    },
    carrefour: {
        draft: [ requestStatus.draft, requestStatus.todo, requestStatus.cancelled ],
        todo: [ requestStatus.draft, requestStatus.todo, requestStatus.onGoing, requestStatus.validated, requestStatus.cancelled ],
        onGoing: [ requestStatus.onGoing, requestStatus.toValidate, requestStatus.validated, requestStatus.cancelled ],
        toValidate: [ requestStatus.onGoing, requestStatus.toValidate, requestStatus.validated, requestStatus.cancelled ],
        validated: [ requestStatus.validated, requestStatus.quoteCreated, requestStatus.cancelled ],
        quoteCreated: [ requestStatus.quoteCreated, requestStatus.completed, requestStatus.cancelled ],
        completed: [ requestStatus.quoteCreated, requestStatus.completed, requestStatus.cancelled ],
        cancelled: [ requestStatus.todo, requestStatus.onGoing, requestStatus.toValidate, requestStatus.cancelled ],
    },
    carter_cash: {
        draft: [ requestStatus.draft, requestStatus.todo, requestStatus.cancelled ],
        todo: [ requestStatus.draft, requestStatus.todo, requestStatus.onGoing, requestStatus.validated, requestStatus.cancelled ],
        onGoing: [ requestStatus.onGoing, requestStatus.toValidate, requestStatus.validated, requestStatus.cancelled ],
        toValidate: [ requestStatus.onGoing, requestStatus.toValidate, requestStatus.validated, requestStatus.cancelled ],
        validated: [ requestStatus.validated, requestStatus.quoteCreated, requestStatus.cancelled ],
        quoteCreated: [ requestStatus.quoteCreated, requestStatus.completed, requestStatus.cancelled ],
        completed: [ requestStatus.quoteCreated, requestStatus.completed, requestStatus.cancelled ],
        cancelled: [ requestStatus.todo, requestStatus.onGoing, requestStatus.toValidate, requestStatus.cancelled ],
    },
};

export const requestStatusClientStateMachine: { [key: string]: string[] } = {
    draft: [ requestStatus.draft, requestStatus.todo ],
    todo: [ requestStatus.draft, requestStatus.todo, requestStatus.validated ],
    onGoing: [ requestStatus.onGoing ],
    toValidate: [ requestStatus.onGoing, requestStatus.toValidate, requestStatus.validated],
    validated: [ requestStatus.validated, requestStatus.goodForOrder ],
    quoteCreated: [ requestStatus.quoteCreated, requestStatus.goodForOrder ],
    goodForOrder: [ requestStatus.goodForOrder ],
    completed: [ requestStatus.completed ],
    cancelled: [ requestStatus.cancelled ],
};

export const requestDocumentTypes: any = {
    MC: "request_mc",
    MCL: "request_mcl",
    OTHER: "request_comment",
    BDC: "request_bdc",
    QUOTE: "request_quote",
    SUPPLIER_QUOTE: "request_supplier_quote",
    ODP: "request_odp",
    CAMPAIGN_REPORT: "request_campaign_report",
    CREA: "request_crea",
    TECHNICAL_MATRIX: "request_technical_matrix",
    BRIEF: "request_brief",
    ACCOUNT_REPRINT: "request_account_reprint"
};

export const monocleDefaultOptions = {
    targetBoth: "both",
    targetAgeMin: "18",
    targetAgeMax: "+",
    targetType: "Multi",
    targetStrategy: "acq",
    targetGeo: "Iris",
};

export const monocleCreativeOptionalFields = [
    "typologyCampaign",
    "product",
    "socialBoostType",
    "period",
    "subObjective",
];

export const monocleCreativeGroupOptionalFields = [
    "typologyCampaigns",
    "products",
    "socialBoostTypes",
    "periods",
    "subObjectives",
];

export const monocleMatchingOptionalFields = {
    typologyCampaign: "typologyCampaigns",
    product: "products",
    socialBoostType: "socialBoostTypes",
    period: "periods",
    subObjective: "subObjectives",
};

export const notificationChannels = {
    email: "notificationByEmail",
    app: "notificationByApp",
};
export const notificationsTabs = {
    request : "request",
    socle : "socle",
    socleApprovalWorkflow : "socle_approval_workflow",
};

export const hideFeatureNotification = {
    hideRequest : "HIDE_REQUEST",
    hideSocle : "HIDE_SOCLE",
};

export const notificationRequestTrigger = {
    allRequesters: "allRequesters",
    myRequests: "myRequests",
    usersRequest: "usersRequest",
};
export const notificationAllDetails = {
    allNotificationsDetails: "all",
};
export const notficationStatusDetails = {
    allStatus: "allStatus",
};

export const APPLICATION_JO = "justif-online";

export const AiInteractionTypes = {
    campaignQuery : "campaign_query",
    campaignMcp : "campaign_mcp",
};

export const mcpStatusLabelKeys: Record<string, string> = {
    compute_kpis: "mcpStatusComputeKpis",
    compute_campaign_kpis: "mcpStatusComputeCampaignKpis",
    report_synthese: "mcpStatusReportSynthese",
    count_stores: "mcpStatusCountStores",
    list_campaigns: "mcpStatusListCampaigns",
    get_details: "mcpStatusGetDetails",
    find_entity_campagne: "mcpStatusFindCampagne",
    find_entity_magasin: "mcpStatusFindMagasin",
    find_entity_region: "mcpStatusFindRegion",
    find_entity: "mcpStatusFindEntity",
};

export const MAX_AI_LAST_QUESTIONS: number = 8;
